function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon/navigation/ic-check");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, React.createElement("path", {
  d: "M8.795,15.875 L5.32961259,12.4096126 C4.9400637,12.0200637 4.30882497,12.0189484 3.91790203,12.4071184 L3.915,12.41 C3.52426097,12.7979873 3.52203029,13.4292698 3.91001764,13.8200088 C3.91084509,13.8208422 3.91167402,13.821674 3.91250442,13.8225044 L8.08789322,17.9978932 C8.47841751,18.3884175 9.11158249,18.3884175 9.50210678,17.9978932 L20.09,7.41 C20.4793607,7.02063925 20.4793607,6.38936075 20.09,6 L20.09,6 C19.7005854,5.61058539 19.0692656,5.61043629 18.6796671,5.9996669 L8.795,15.875 Z",
  id: "path-8574169"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "icon/navigation/ic-check",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-8574169"
})), React.createElement("use", {
  id: "icon/navigation/check_24px",
  fill: "#02bd70",
  xlinkHref: "#path-8574169"
}));

var SvgIcCheckGreen = function SvgIcCheckGreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcCheckGreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-check-green.1e7a0db6.svg";
export { ForwardRef as ReactComponent };